const sponsors = {
  "zdolbuniv government": "../../../../assets/mainPage/sponsors/zd_gov.jpg",
  "ukrainian fond": "../../../../assets/mainPage/sponsors/ukr_fond.jpg",
  vyp: "../../../../assets/mainPage/sponsors/vyp.jpg",
  "our future": "../../../../assets/mainPage/sponsors/fut.jpg",
  gull: "../../../../assets/mainPage/sponsors/gull.jpg",
  psd: "../../../../assets/mainPage/sponsors/psd.jpg",
};

export default sponsors;
